function generateTimeSlots() {
  const slots = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 5) {
      slots.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
    }
  }
  return slots;
}

function currentTimeRoundedToFive() {
  const d = new Date();
  d.setSeconds(0, 0);
  const rounded = Math.round(d.getMinutes() / 5) * 5;
  if (rounded === 60) {
    d.setHours(d.getHours() + 1);
    d.setMinutes(0);
  } else {
    d.setMinutes(rounded);
  }
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

function findParentData(component, _name) {
  let el = component.$el.parentElement;
  while (el) {
    if (el._x_dataStack) {
      const match = el._x_dataStack.find((d) => d.selectedTime !== undefined);
      if (match) return match;
    }
    el = el.parentElement;
  }
  return null;
}

function parseDdMmYyyy(str) {
  if (!str) return null;
  const parts = str.split("/");
  if (parts.length !== 3) return null;
  const [dd, mm, yyyy] = parts;
  return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
}

export default function registerDatepicker(Alpine) {
  Alpine.data("datepickerSync", (initialDisplay) => ({
    init() {
      if (initialDisplay) {
        this.$refs.datepickerInput.value = initialDisplay;
      }
    },
    syncDate(_event) {
      const display = this.$refs.datepickerInput.value;
      const iso = parseDdMmYyyy(display);
      this.$refs.hiddenInput.value = iso || "";
    }
  }));

  Alpine.data("datetimeSync", (initialDate, initialTime) => ({
    selectedTime: initialTime || currentTimeRoundedToFive(),
    init() {
      if (initialDate) {
        this.$refs.datepickerInput.value = initialDate;
      }
    },
    syncDateTime() {
      const display = this.$refs.datepickerInput.value;
      const iso = parseDdMmYyyy(display);
      this.$refs.hiddenInput.value = iso ? `${iso}T${this.selectedTime}` : "";
    }
  }));

  Alpine.data("timepickerDropdown", (initial) => ({
    open: false,
    selected: initial || currentTimeRoundedToFive(),
    slots: generateTimeSlots(),
    scrollToSelected() {
      const list = this.$el.querySelector("ul");
      if (!list) return;
      const target = this.selected || currentTimeRoundedToFive();
      const buttons = list.querySelectorAll("button[type='button']");
      let activeBtn = null;
      for (const btn of buttons) {
        if (btn.textContent.trim() === target) {
          activeBtn = btn;
          break;
        }
      }
      if (!activeBtn) return;
      let scrollable = list.parentElement;
      while (scrollable) {
        const style = window.getComputedStyle(scrollable);
        if (/(auto|scroll)/.test(style.overflowY)) break;
        scrollable = scrollable.parentElement;
      }
      if (!scrollable) return;
      const offset = activeBtn.offsetTop - scrollable.clientHeight / 2 + activeBtn.offsetHeight / 2;
      scrollable.scrollTop = Math.max(0, offset);
    },
    toggle() {
      this.open = !this.open;
      if (this.open) {
        requestAnimationFrame(() => requestAnimationFrame(() => this.scrollToSelected()));
      }
    },
    pick(slot) {
      this.selected = slot;
      this.open = false;
      const parent = findParentData(this, "datetimeSync");
      if (parent) {
        parent.selectedTime = slot;
        parent.syncDateTime();
      }
    }
  }));
}
